import React from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import "../CostomNewsSearchDetails/CustomNewsSearchDetails.css";
import halflines from "../../../../Assets/halflines.svg";
const PdfCustomNewsSearch = ({ dataForInformation }) => {
    const feedBoxOneData = localStorage.getItem("cns")
    const feedBoxOne = (JSON.parse(feedBoxOneData))?.data
    const initialData = (item) => {
        const data = item?.split(" ");
        return `${data?.[0]?.charAt(0).toUpperCase() || ""}${data?.[1]?.charAt(0).toUpperCase() || ""
            }`;
    };

    return (
        <div className='main-CustomNewsSearchDetails' style={{ position: 'relative' }}>



            <div className='add-contents-cards'>
                {

                    feedBoxOne ?
                        <div className='CI-cards-content' style={{ pageBreakInside: "avoid" }}>
                            <div className='adding-content' style={{ pageBreakInside: "avoid" }}>
                                <div className='two-head-comp'>
                                    <div className="result-tags-icon-comp">
                                        <div className="checkbox-result-tag-comp">
                                            <p className="result-comp">
                                                {feedBoxOne?.length || 0} {feedBoxOne?.length > 1 ? "Results" : "Result"}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    {feedBoxOne?.length ? <>
                                        {feedBoxOne?.map((articleData, index) => (
                                            <div key={index} className='rest-cont' style={{ pageBreakInside: "avoid" }}>
                                                <div className='joi-circle-text-comp'>
                                                    <div className='jo-icon-comp'><p>{dataForInformation?.name ? initialData(dataForInformation?.name) : dataForInformation?.name}</p></div>
                                                    <div className='date-name-csoon'>
                                                        <div><p className='jobsohio-name-comp'>{articleData?.article?.title?.length > 100
                                                            ? articleData?.article?.title.slice(0, articleData?.article?.title.slice(0, 100).lastIndexOf(" ")) + "..."
                                                            : articleData?.article?.title}
                                                        </p></div>
                                                        <div className="both-news-time-comp">
                                                            <p className="news-comp">
                                                                <a
                                                                    href={articleData?.article?.url}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                >
                                                                    {
                                                                        articleData?.article?.url
                                                                            ? (articleData.article.url.split('https://')[1]?.length > 50
                                                                                ? articleData.article.url.split('https://')[1].slice(0, 50) + '...'
                                                                                : articleData.article.url.split('https://')[1])
                                                                            : ''
                                                                    }
                                                                </a>
                                                                |
                                                            </p>
                                                            <p className="today-comp">
                                                                {new Date(
                                                                    articleData?.article?.date
                                                                ).toLocaleDateString("en-US", {
                                                                    month: "long",
                                                                    day: "numeric",
                                                                    year: "numeric",
                                                                })}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='content-pera-comp'>
                                                    <p className="bold-content-pera-comp">
                                                        {articleData.summary}
                                                    </p>
                                                    <div className="Intersect-jb-nf-comp">
                                                        {articleData?.tags?.map((tag, idx) => (
                                                            <p key={idx}>{tag}</p>
                                                        ))}
                                                    </div>
                                                </div>
                                                <hr className='hr-tag-ci' />
                                            </div>
                                        ))}
                                    </> : <p className='text-center-result'>No results found</p>}
                                </div>
                            </div>
                        </div> : <div className='CI-cards-content'><div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "20px" }}>Data Not Available </div></div>
                }
            </div>


        </div >

    )
}

export default PdfCustomNewsSearch
